var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50003 22.125C4.49778 22.4206 4.61288 22.7051 4.82008 22.916C5.02728 23.1269 5.30966 23.247 5.6053 23.25H18.3948C18.6904 23.247 18.9728 23.1269 19.18 22.916C19.3872 22.7051 19.5023 22.4206 19.5 22.125V7.125H4.50003V22.125ZM6.00003 8.625H18V21.75H6.00003V8.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.125H9.375V19.5H7.875V10.125ZM11.25 10.125H12.75V19.5H11.25V10.125ZM14.625 10.125H16.125V19.5H14.625V10.125ZM15.375 4.125V1.875C15.375 1.24416 14.9302 0.75 14.3625 0.75H9.6375C9.06975 0.75 8.625 1.24416 8.625 1.875V4.125H3V5.625H21V4.125H15.375ZM10.125 2.25H13.875V4.125H10.125V2.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.bbd36c78cf3f281ce9b808f037cc7c87.svg";
export { ForwardRef as ReactComponent };